import { api } from '@cma/app'
import {
  RestoreBrokerAccountMutation,
  RestoreBrokerAccountMutationVariables
} from '@cma/generated/graphql'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { gql } from 'graphql-request'

export function useRestoreBrokerAccount() {
  const queryClient = useQueryClient()

  return useMutation<
    RestoreBrokerAccountMutation,
    Error,
    RestoreBrokerAccountMutationVariables
  >(
    ({ id }) => {
      const query = gql`
        mutation RestoreBrokerAccount($id: ID!) {
          restoreBrokerAccount(id: $id) {
            errors
            account {
              id
            }
          }
        }
      `
      return api<
        RestoreBrokerAccountMutation,
        RestoreBrokerAccountMutationVariables
      >({ query, variables: { id } })
    },
    {
      async onSuccess(_, { id }) {
        await Promise.all([
          queryClient.invalidateQueries(['broker', id]),
          queryClient.invalidateQueries(['brokers'])
        ])
      }
    }
  )
}
